<template>
  <div class="piggery">
    <div class="banner" :style="`background-image:url(${banner.picUrl})`" @click="goBannerUrl" :class="{canClick: banner.connection}">
      <h1 class="font-60">智能养猪流程闭环 <br />实现人猪分离的养殖模式</h1>
    </div>

    <div class="middle-content">
      <section>
        <h1>农芯数科简介</h1>
        <p class="pb20 text-retract">内容</p>
      </section>
    </div>

  </div>
</template>

<script>
import { getSession, setSession } from '@/utils/index'
export default {
  name: 'groupEdition',
  data () {
    return {
      banner: {
        picUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
      }
    }
  },
  mounted () {
    if (!getSession('bannerPic')) {
      this.getBannerPage()
    } else {
      this.banner = getSession('bannerPic').core_compete
    }
    this.$scroll.reveal('.banner h1', {
      distance: '50px',
      origin: 'left',
      duration: 1000
    })
  },
  methods: {
    /**
    * 获取 banner 图片
    */
    async getBannerPage () {
      const params = {
        currentPage: 1,
        pageSize: 100
      }
      const res = await this.API.basic.getBannerPage(params) || []
      // eslint-disable-next-line prefer-const
      let arr = {}
      res.data.map(o => {
        this.$set(arr, o.remark, { picUrl: o.pictureUrl, connection: o.connection })
      })
      this.banner = arr.core_compete
      setSession('bannerPic', arr)
    },
    /** 跳转banner配置连接 */
    goBannerUrl () {
      if (!this.banner.connection) {
        return ''
      }
      window.open(this.banner.connection)
    }
  }
}
</script>
